import { createCustomFetch } from "@/shared/utils";
import { errorMiddleware, tokenMiddleware } from "@/shared/middlewares";
import type { Middleware } from "@/shared/utils/middleware.util";

// TODO: ADD HEADER 'x-payping-user-hash' TO FETCH
const middlewares: Middleware[] = [tokenMiddleware, errorMiddleware /* parserMiddleware */];

const refundClient = createCustomFetch(middlewares);
export default refundClient;
